import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import "../styles/home.css";

function Home() {
  // Step 1: Create state to track whether the button is clicked
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  // Step 2: Function to handle button click and update state
  const handleHireButtonClick = () => {
    setIsButtonClicked(true);
    // Set a timer to reset the button state after 3 seconds
    setTimeout(() => {
      setIsButtonClicked(false);
    }, 3000);
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const parallaxElements = document.querySelectorAll(".parallax");

      parallaxElements.forEach((element) => {
        const parallaxSpeed = element.dataset.speed || 1;
        element.style.transform = `translateY(${
          scrollPosition * parallaxSpeed
        }px)`;
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Container fluid className="home">
      <Row>
        <Col
          lg="6"
          md="6"
          sm="6"
          xs="6"
          className="home-left parallax"
          data-speed="0.5"
        >
          <span className="cloud-border">Hi I'm</span>
          <h1>PRAVEENGANTH</h1>
          <p>
            A young <span>Web Developer</span> with creative ideas and good
            skills in <span>MERN</span>{" "}
          </p>
          <br />
          <button className="hire-me" onClick={handleHireButtonClick}>
            Hire Me
          </button>
          {isButtonClicked && (
            <div className="overlay-image">
              <img
                src="https://cdna.artstation.com/p/assets/images/images/042/676/328/original/leo-bryan-arief-sprite-0002.gif?1635169542"
                alt="Overlay Image"
              />
            </div>
          )}
        </Col>
        <Col
          lg="6"
          md="6"
          sm="6"
          xs="6"
          className="home-right parallax"
          data-speed="0.5"
        >
          <div className="hero-image">
            <img
              src="https://www.vippng.com/png/full/78-787473_anime-boy-blackhair-raven-anime-boy-black-and.png"
              alt=""
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
export default Home;
